import { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { PuffLoader } from 'react-spinners';
import type { DatePickerProps } from 'antd';
import { DatePicker } from 'antd';
import { Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import dayjs from 'dayjs';
import TableDynamicPage from './components/TableDynamicPage';
import { authInfoSelect } from '../../entities/auth';
import { useSelector } from 'react-redux';
import { rKeeperSelect } from '../../entities/rKeeper';
import { cssOverride } from '../../utils/const';
import { isNotEmptyArray } from '../../utils/functions';

moment().format();

const translateKeys = data => {
    return data.map(entry => {
        const translatedEntry: any = {};
        for (const key in entry) {
            switch (key) {
                case 'Кредитные карты':
                    translatedEntry.credit = entry[key];
                    break;
                case 'Наличность':
                    translatedEntry.cash = entry[key];
                    break;
                case 'Платежные карты':
                    translatedEntry.cards = entry[key];
                    break;
                case 'ПДС Депозит':
                    translatedEntry.pds = entry[key];
                    break;
                case 'Общая выручка':
                    translatedEntry.revenue = entry[key];
                    break;
                case 'Открытые столы':
                    translatedEntry.tables = entry[key];
                    break;
                case 'Чистая выручка':
                    translatedEntry.net = entry[key];
                    break;
                default:
                    translatedEntry[key] = entry[key]; // Keeps the original value for keys that don't need translation
            }
        }
        return translatedEntry;
    });
};

const DynamicPage = () => {
    const { lastShiftClosed } = useSelector(rKeeperSelect);
    const [tableData, setTableData] = useState([]);
    const [tableDataHour, setTableDataHour] = useState([]);
    const [loading, setLoading] = useState(true);
    const [datePickerValue, setDatePickerValue] = useState<
        string | undefined
    >();
    const [valueRadio, setValueRadio] = useState(false);
    const { shop } = useSelector(authInfoSelect);

    useEffect(() => {
        if (shop && lastShiftClosed) {
            const url = `${process.env.REACT_APP_API_URL}/shops/${
                shop.id
            }/reports/revenue/hour/days?date=${
                datePickerValue ? datePickerValue : lastShiftClosed.SHIFTDATE
            }`;
            Promise.all([
                fetch(url, {
                    // credentials: 'include',
                    headers: {
                        accept: 'application/json',
                        Authorization: `${localStorage.getItem('accessToken')}`,
                        'Content-Type': 'application/json',
                    },
                })
                    .then(res => res.json())
                    .catch(() => false),
            ])
                .then(([data]) => {
                    setTableDataHour([]);
                    setTableData([]);
                    if (data && data[0] && isNotEmptyArray(data[0].data)) {
                        const formedData = translateKeys(data[0].data);

                        const formatedData = formedData.map((i, ind) => {
                            return {
                                key: ind,
                                period: i.period,
                                cards: i.cards ? i.cards : 0,
                                pds: i.pds ? i.pds : 0,
                                cash: i.cash ? i.cash : 0,
                                credit: i.credit ? i.credit : 0,
                                tables: i.tables ? i.tables : 0,
                                revenue: i.revenue ? i.revenue - i.pds : 0,
                                net: i.net ? i.net - i.pds : 0,
                            };
                        });

                        const result = formatedData.map((item, index, arr) => {
                            if (index === 0) {
                                return {
                                    key: index,
                                    period: item.period,
                                    cards: item.cards ? item.cards : 0,
                                    pds: item.pds ? item.pds : 0,
                                    cash: item.cash ? item.cash : 0,
                                    credit: item.credit ? item.credit : 0,
                                    tables: item.tables ? item.tables : 0,
                                    revenue: item.revenue ? item.revenue : 0,
                                    net: item.net ? item.net : 0,
                                };
                            } else {
                                const lastValue = arr[index - 1];

                                return {
                                    key: index,
                                    period: item.period,
                                    cards: item.cards
                                        ? item.cards - lastValue.cards
                                        : 0,
                                    pds: item.pds
                                        ? item.pds - lastValue.pds
                                        : 0,
                                    cash: item.cash
                                        ? item.cash - lastValue.cash
                                        : 0,
                                    credit: item.credit
                                        ? item.credit - lastValue.credit
                                        : 0,
                                    tables: item.tables - lastValue.tables,
                                    revenue: item.revenue
                                        ? item.revenue - lastValue.revenue
                                        : 0,
                                    net: item.net
                                        ? item.net - lastValue.net
                                        : 0,
                                };
                            }
                        });

                        setTableDataHour(formatedData);
                        setTableData(result);
                        setLoading(false);
                    } else {
                        setTableData([]);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    setTableData([]);
                    setLoading(false);
                });
        }
    }, [lastShiftClosed, shop, datePickerValue]);

    const disabledDate: DatePickerProps['disabledDate'] = current => {
        return current && current > dayjs().endOf('day');
    };

    const onDateChange: DatePickerProps['onChange'] = (
        date: dayjs.Dayjs | null,
        dateString: string | string[]
    ) => {
        if (date) {
            const apiFormatDate = date.format('YYYY-MM-DD');
            setDatePickerValue(apiFormatDate);
            setLoading(true);
        } else {
            setDatePickerValue(undefined);
        }
    };

    const handleChange = (e: RadioChangeEvent) => {
        setValueRadio(e.target.value);
    };

    return (
        <Wrapper>
            <Header>
                <Title>Динамика</Title>
                <Radio.Group value={valueRadio} onChange={handleChange}>
                    <Radio.Button value={false}>С накоплением</Radio.Button>
                    <Radio.Button value={true}>По часам</Radio.Button>
                </Radio.Group>
                <StyledCaledarWrapper>
                    <DatePicker
                        onChange={onDateChange}
                        value={
                            datePickerValue
                                ? dayjs(datePickerValue, 'YYYY-MM-DD')
                                : lastShiftClosed?.SHIFTDATE
                                  ? dayjs(
                                        lastShiftClosed.SHIFTDATE,
                                        'YYYY-MM-DD'
                                    )
                                  : null
                        }
                        format="DD-MM-YYYY"
                        disabledDate={disabledDate}
                    />
                </StyledCaledarWrapper>
            </Header>
            <div>
                {loading ? (
                    <PuffLoader color="#E65E20" cssOverride={cssOverride} />
                ) : (
                    <TableDynamicPage
                        data={valueRadio ? tableData : tableDataHour}
                        loading={loading}
                        valueRadio={valueRadio}
                    />
                )}
            </div>
        </Wrapper>
    );
};

export default DynamicPage;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* min-width: 100%; */
    width: 100%;
    height: 100%;
    top: 0px;
    background-color: #fff;
    padding: 16px 0px 16px 0px;

    .ant-table-thead > tr > th {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: left;
    }

    .ant-table-footer {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: left;
    }

    table > tbody > tr > td {
        background-color: #ffffff;
        font-family: Inter;
        border: 1px solid #efefef;
        color: #333333;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.8px;
        text-align: left;
        height: 30px;
    }
`;

const Header = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    top: 0px;
    margin-bottom: 20px;
    /* gap: 30px; */
`;

const Title = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.02em;
    color: #000000;
`;

const StyledCaledarWrapper = styled.div`
    /* width: 250px; */
    color: #ffffff;
    display: flex;
    gap: 10px;
    color: #ffffff;

    & svg {
        width: 20px;
        height: 20px;
    }
    .ant-picker {
        background-color: #a7388e;
        font-family: Inter;
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
        text-align: center;
        color: #ffffff;
    }

    .ant-picker .ant-picker-input,
    .ant-picker .ant-picker-range,
    .ant-picker .ant-picker-input-active .ant-picker-input-placeholder {
        display: flex;
        flex-direction: row-reverse;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
        color: #ffffff;
    }

    .ant-picker .ant-picker-input .ant-picker-input-active {
        color: #ffffff !important;
    }

    .ant-picker .ant-picker-input .ant-picker-input-placeholder {
        color: #ffffff !important;
    }

    .ant-picker .ant-picker-input span.ant-picker-suffix,
    .ant-picker.ant-picker-range span.ant-picker-suffix {
        order: -1;
        margin-left: 0;
        margin-right: 10px; /* Для отступа иконки от текста */
        color: #ffffff;
    }

    .ant-picker.ant-picker-range.ant-picker-range-separator {
        color: #ffffff !important;
        /* display: none; */
    }

    .ant-picker-range-separator > span {
        color: #ffffff !important; /* Замените #ваш_цвет на нужный код цвета */
    }

    .ant-picker-clear {
        color: #ffffff !important; /* Замените #ваш_цвет на нужный код цвета */
    }

    .ant-picker .ant-picker-clear {
        position: absolute;
        right: 9px;
        /* color: #ffffff !important; */
    }
`;
